import { QueryStatus } from '../../../../../types'
import {OperacionADCM} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpADCM} from "../api/httpADCM";

export const useOperacionADCM = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionADCM>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpADCM.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
